import Tag from '@/models/Tag';
import { AxiosError } from 'axios';

export enum TagTypes {
    GET_TAGS_CLEAR = '@tag/GET_TAGS_CLEAR',
    GET_TAGS_REQUEST = '@tag/GET_TAGS_REQUEST',
    GET_TAGS_SUCCESS = '@tag/GET_TAGS_SUCCESS',
    GET_SUGGESTION_TAGS_SUCCESS = '@tag/GET_SUGGESTION_TAGS_SUCCESS',
    GET_TAGS_FAILURE = '@tag/GET_TAGS_FAILURE',
}

export interface Tags {
    tags: [Tag];
    suggestionTags: [Tag];
}

export interface TagsState {
    data: Tags;
    loading: boolean;
    hasError: boolean;
    error?: AxiosError;
}
